import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";

export function FooterLinks({ linkClassName = "hover:text-[#3F6E85] transition-colors", separator = null, className = "flex flex-wrap gap-x-5 gap-y-2" }) {
  const { t } = useLang();
  const links = [
    ["/about", t("about_link"), "footer-about"],
    ["/contact", t("contact_link"), "footer-contact"],
    ["/terms", t("terms_link"), "footer-terms"],
    ["/privacy", t("privacy_link"), "footer-privacy"],
  ];
  return (
    <span className={className}>
      {links.map(([to, label, id], i) => (
        <React.Fragment key={to}>
          {separator && i > 0 && separator}
          <Link to={to} className={linkClassName} data-testid={id}>{label}</Link>
        </React.Fragment>
      ))}
    </span>
  );
}
